import React, { useState, useRef, useEffect } from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxDropdownWithFilter from 'components/reusable/AdxDropdownWithFilter'
import defaultAvatar from 'assets/images/default_avatar.png'

import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import { getAllStaffNotAdmins, postAdmin, getAdminById } from 'services/api/admin-accessibility'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import * as Yup from 'yup'
import { handleValidationErrors } from 'services/helper/handleValidationErrors'
import AdxButton from 'components/custom/AdxButton'

const AddAdminModal = ({ showAddAdminModal, handleCloseAddAdminModal, selectedAdminCardId }) => {
  const formikRef = useRef()

  const [dropdownFilterOptions, setDropdownFilterOptions] = useState()

  const queryClient = useQueryClient()

  const [selectValue, setSelectValue] = useState('')
  const [selectedAdminItem, setSelectedAdminItem] = useState('')

  const handleSetSelectValue = (event) => {
    setSelectValue(event.target.value)
    formikRef.current.setFieldValue('staff_id', event.target.value.staff_id)
  }

  const handleCloseModal = () => {
    handleCloseAddAdminModal()
    setInitialValues({
      staff_id: '',
      super_admin: false,
      permissions: [],
    })
    setSelectValue('')
    setSelectedAdminItem('')
  }

  const [initialValues, setInitialValues] = useState({
    staff_id: '',
    super_admin: false,
    permissions: [],
  })

  const validationSchema = Yup.object().shape({
    staff_id: Yup.number().required('Employee is required'),
  })

  const allStaffNotAdmins = useQuery('allStaffNotAdmins', async () => {
    const { data } = await getAllStaffNotAdmins()
    return data
  })

  const adminById = async () => {
    try {
      const res = await getAdminById(selectedAdminCardId)
      setInitialValues({
        staff_id: res?.data?.staff_id,
        super_admin: res?.data?.super_admin,
        // permission id 11 (used for approval center) is filtered out
        permissions: res?.data?.permissions?.map((item) => item.id).filter((el) => el !== 11),
        // .filter((el) => el !== 10),
      })
      setSelectedAdminItem(res?.data)
      setSelectValue(res?.data)
    } catch (e) {
      console.log('error')
    }
  }

  useEffect(() => {
    if (selectedAdminCardId) {
      adminById()
    }
  }, [selectedAdminCardId])

  const mutate = useMutation(
    async (data) => {
      await postAdmin(data)
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries('allAdminsList')
        queryClient.invalidateQueries('allStaffNotAdmins')
        queryClient.invalidateQueries('myAccountData')
        handleCloseModal()
      },
      onError: (e) => {
        if (e.status === 422) {
          handleValidationErrors(e, formikRef)
        } else {
          console.log(e.data.message)
        }
      },
    }
  )

  const handleAllowAllCompanyManagment = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([
        ...formikRef.current.values.permissions,
        1,
        2,
        3,
        4,
        // 10,
        13,
        14,
        15,
      ]),
    ])
    if (
      [
        ...new Set([
          ...formikRef.current.values.permissions,
          1,
          2,
          3,
          4,
          // 10,
          13,
          14,
          15,
        ]),
      ].length >= 18
    ) {
      // await formikRef.current.setFieldValue("permissions", [
      //   ...formikRef.current.values.permissions,
      //   10,
      // ]);
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handleAllowAllStaffManagment = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 5, 6]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 5, 6])].length >= 18) {
      // await formikRef.current.setFieldValue("permissions", [
      //   ...formikRef.current.values.permissions,
      //   10,
      // ]);
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handleAllowAllPayrollManagment = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 7, 8, 9]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 7, 8, 9])].length >= 18) {
      // await formikRef.current.setFieldValue("permissions", [
      //   ...formikRef.current.values.permissions,
      //   10,
      // ]);
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }
  const handleAllowClaimreimbursementlManagment = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 12]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 12])].length >= 18) {
      // await formikRef.current.setFieldValue("permissions", [
      //   ...formikRef.current.values.permissions,
      //   10,
      // ]);
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }
  const handleAllowAppraisalManagement = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 10, 17]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 10, 17])].length >= 18) {
      // await formikRef.current.setFieldValue("permissions", [
      //   ...formikRef.current.values.permissions,
      //   10,
      // ]);
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handleAllowRecruitmentManagement = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 18]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 18])].length >= 18) {
      await formikRef.current.setFieldValue('permissions', [
        ...formikRef.current.values.permissions,
        10,
      ])
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handleAllowAttendanceTracking = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 20]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 20])].length >= 18) {
      await formikRef.current.setFieldValue('permissions', [
        ...formikRef.current.values.permissions,
        10,
      ])
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handleAllowAnnouncementsManagement = async () => {
    await formikRef.current.setFieldValue('permissions', [
      ...new Set([...formikRef.current.values.permissions, 21]),
    ])
    if ([...new Set([...formikRef.current.values.permissions, 21])].length >= 18) {
      await formikRef.current.setFieldValue('super_admin', true)
    }
  }

  const handlePermissions = (e, permissionId) => {
    if (e.target.checked) {
      formikRef.current.setFieldValue('permissions', [
        ...formikRef.current.values.permissions,
        permissionId,
      ])
      if ([...formikRef.current.values.permissions, permissionId].length >= 18) {
        formikRef.current.setFieldValue('super_admin', true)
        formikRef.current.setFieldValue('permissions', [
          ...formikRef.current.values.permissions,
          permissionId,
          // 10,
        ])
      }
    } else {
      let array = [...formikRef.current.values.permissions]

      // array = array.filter((item) => item !== 10);
      const index = array.indexOf(permissionId)
      if (index > -1) {
        array.splice(index, 1)
      }
      formikRef.current.setFieldValue('permissions', array)
      formikRef.current.setFieldValue('super_admin', false)
    }
  }
  const handleOnSubmit = (values, actions) => {
    mutate.mutate(values)
  }

  return (
    <AdxFormModal
      disableAutoFocus
      title="Company and staff management admin"
      open={showAddAdminModal}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      sxModal={{ minWidth: 700 }}
      enableFooter
      actionText={selectedAdminCardId ? 'Save' : 'Create'}
      handleAction={() => formikRef.current.submitForm()}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        innerRef={formikRef}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => handleOnSubmit(values, actions)}
      >
        {({ values, errors, touched, handleChange, setFieldValue, handleSubmit }) => (
          <Form>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={7}>
                  <Field
                    as={AdxDropdownWithFilter}
                    name="staff_id"
                    label="Employee"
                    allOptions={[selectedAdminItem, ...allStaffNotAdmins?.data].filter(
                      (item) => item
                    )}
                    setOptions={setDropdownFilterOptions}
                    filters={['name']}
                    sx={{ width: '100%' }}
                    value={selectValue}
                    onChange={(e) => handleSetSelectValue(e)}
                    isErrorShown={errors.staff_id && touched.staff_id}
                    errorMessage={<ErrorMessage name="staff_id" component={AdxErrorMessage} />}
                    renderValue={(option) => {
                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          {option?.profile_image_url ? (
                            <Box
                              sx={{
                                backgroundColor: 'gray-background.main',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                              }}
                            >
                              {/* <Box  /> */}
                              <Avatar
                                src={option?.profile_image_url}
                                sx={{ width: '30px', height: '30px' }}
                              />
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                backgroundColor: 'gray-background.main',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                              }}
                            >
                              <Avatar src={defaultAvatar} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                          )}
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                            }}
                          >
                            <Typography variant="body1">{option.name}</Typography>
                          </Box>
                        </Box>
                      )
                    }}
                  >
                    {dropdownFilterOptions?.map((item) => (
                      <AdxMenuItem value={item} selectedvalue={selectValue}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 1,
                            gap: 2,
                          }}
                        >
                          {item.profile_image_url ? (
                            <Box
                              sx={{
                                backgroundColor: 'gray-background.main',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                              }}
                            >
                              <Avatar
                                src={item?.profile_image_url}
                                sx={{ width: '30px', height: '30px' }}
                              />
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                backgroundColor: 'gray-background.main',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                              }}
                            >
                              <Avatar src={defaultAvatar} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                          )}
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                            }}
                          >
                            <Typography variant="body1">{item.name}</Typography>
                          </Box>
                        </Box>
                      </AdxMenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item xs={12} lg={5}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Superadmin"
                      description="Superadmin will have full access to all modules"
                      // have to recheck the perms, current solution is just a quickfix to enable superadmin, superadmin should be specific number of perms rather than a more-than-equal-to range. currently like this as when new features were added, prev devs did not update the perms and certain perms were filtered out but still available (10,11,16 etc)
                      checked={values.permissions.length >= 18}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue('super_admin', true)
                          formikRef.current.setFieldValue('permissions', [
                            ...new Set([
                              ...values.permissions,
                              1,
                              2,
                              3,
                              4,
                              13,
                              14,
                              15,
                              5,
                              6,
                              7,
                              8,
                              9,
                              12,
                              10,
                              17,
                              11,
                              18,
                              19,
                              20,
                              21,
                            ]),
                          ])
                        } else {
                          setFieldValue('super_admin', false)
                          formikRef.current.setFieldValue('permissions', [])
                        }
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">1. Company management</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAllCompanyManagment()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Company file"
                      description="Manage company basic information, bank and statutory details"
                      checked={values.permissions.includes(1)}
                      onChange={(e) => handlePermissions(e, 1)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Admin management"
                      description="Add, edit or remove admins, manage admin permissions"
                      checked={values.permissions.includes(13)}
                      onChange={(e) => handlePermissions(e, 13)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Department management"
                      description="Add, edit or remove departments, manage head of departments"
                      checked={values.permissions.includes(14)}
                      onChange={(e) => handlePermissions(e, 14)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Approval routing management"
                      description="Add, edit or remove approval flows"
                      checked={values.permissions.includes(15)}
                      onChange={(e) => handlePermissions(e, 15)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Leave settings"
                      description="Manage operation days, leave credit request policy, leave policy"
                      checked={values.permissions.includes(2)}
                      onChange={(e) => handlePermissions(e, 2)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Claim settings"
                      description="Manage standard and milage claims, claim approval policy"
                      checked={values.permissions.includes(3)}
                      onChange={(e) => handlePermissions(e, 3)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Payroll settings"
                      description="Manage payroll, overtime policy, payroll categories"
                      checked={values.permissions.includes(4)}
                      onChange={(e) => handlePermissions(e, 4)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Attendance settings"
                      description="Manage shift schedule and attendance tracking"
                      checked={values.permissions.includes(19)}
                      onChange={(e) => handlePermissions(e, 19)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">2. Staff Management</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAllStaffManagment()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Employee file"
                      description="Manage employee basic details contact details"
                      checked={values.permissions.includes(5)}
                      onChange={(e) => handlePermissions(e, 5)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Employee payroll details"
                      description="Manage employee bank and statutory body details"
                      checked={values.permissions.includes(6)}
                      onChange={(e) => handlePermissions(e, 6)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">3. Payroll</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAllPayrollManagment()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Payroll run"
                      description="Manage company basic information, bank and statutory details"
                      checked={values.permissions.includes(7)}
                      onChange={(e) => handlePermissions(e, 7)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Payroll history"
                      description="View all payroll history"
                      checked={values.permissions.includes(8)}
                      onChange={(e) => handlePermissions(e, 8)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Yearly reports"
                      description="View all yearly reports"
                      checked={values.permissions.includes(9)}
                      onChange={(e) => handlePermissions(e, 9)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">4. Claim reimbursement</Typography>
                  <AdxButton
                    variant={'ghost'}
                    onClick={() => handleAllowClaimreimbursementlManagment()}
                  >
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Reimburse approved claims"
                      description="Download approved claim(s) into .txt file for making online payment"
                      checked={values.permissions.includes(12)}
                      onChange={(e) => handlePermissions(e, 12)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">5. Appraisal</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAppraisalManagement()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Manage performance settings"
                      description="Manage appraisals, evaluations, forms"
                      checked={values.permissions.includes(10)}
                      onChange={(e) => handlePermissions(e, 10)}
                    />
                  </Box>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Manage team performance"
                      description="Manage team leaders' view settings"
                      checked={values.permissions.includes(17)}
                      onChange={(e) => handlePermissions(e, 17)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">6. Recruitment Management</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowRecruitmentManagement()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Manage job advertisements"
                      description="Create job advertisement and manage applicants"
                      checked={values.permissions.includes(18)}
                      onChange={(e) => handlePermissions(e, 18)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">7. Attendance Tracking</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAttendanceTracking()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Manage attendance tracking"
                      description="Monitor employees' attendance"
                      checked={values.permissions.includes(20)}
                      onChange={(e) => handlePermissions(e, 20)}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  border: 1,
                  borderColor: 'gray-line.main',
                  borderRadius: '4.5px',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 2, borderBottom: 1, borderColor: 'gray-line.main' }}
                >
                  <Typography color="light-gray-text.main">8. Announcements</Typography>
                  <AdxButton variant={'ghost'} onClick={() => handleAllowAnnouncementsManagement()}>
                    Allow All
                  </AdxButton>
                </Box>
                <Box sx={{ px: 1, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box height={'100%'} display="flex" alignItems="center">
                    <AdxFormControlLabel
                      type="no-fill"
                      control={<AdxCheckbox />}
                      label="Manage announcements"
                      description="Create, edit and delete company announcements"
                      checked={values.permissions.includes(21)}
                      onChange={(e) => handlePermissions(e, 21)}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </AdxFormModal>
  )
}

export default AddAdminModal
